import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaintBrush, faWater, faGem, faLeaf, faSun, faMoon, faCircleHalfStroke, } from '@fortawesome/free-solid-svg-icons';
const THEMES = [
    { id: 'blue', label: 'Ocean Blue', color: '#1F4E79', icon: faWater },
    { id: 'purple', label: 'Purple', color: '#6B3FA0', icon: faGem },
    { id: 'green', label: 'Forest Green', color: '#1F6E43', icon: faLeaf },
    { id: 'orange', label: 'Sunset Orange', color: '#C45911', icon: faSun },
    { id: 'dark', label: 'Dark Mode', color: '#2D2D2D', icon: faMoon },
    { id: 'black', label: 'True Black', color: '#7d8c4c', icon: faCircleHalfStroke },
];
const ThemeSelector = () => {
    const [currentTheme, setCurrentTheme] = useState('blue');
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const savedTheme = localStorage.getItem('app-theme');
        if (savedTheme) {
            setCurrentTheme(savedTheme);
            const existing = document.getElementById('theme-stylesheet');
            if (!existing || !existing.href.endsWith(`${savedTheme}.css`)) {
                applyTheme(savedTheme);
            }
        }
    }, []);
    const applyTheme = (theme) => {
        const existing = document.getElementById('theme-stylesheet');
        if (existing) {
            existing.href = `./themes/${theme}.css`;
        }
        else {
            const link = document.createElement('link');
            link.id = 'theme-stylesheet';
            link.rel = 'stylesheet';
            link.href = `./themes/${theme}.css`;
            document.head.appendChild(link);
        }
    };
    const handleThemeSelect = (theme) => {
        setCurrentTheme(theme);
        applyTheme(theme);
        localStorage.setItem('app-theme', theme);
        setOpen(false);
    };
    const selectedThemeLabel = THEMES.find(t => t.id === currentTheme)?.label ?? currentTheme;
    return (React.createElement("div", { className: "theme-selector-wrapper" },
        React.createElement("button", { type: "button", role: "menuitem", className: "profile-settings-action", onClick: () => setOpen(prev => !prev), title: "Change theme", style: { color: 'var(--primary)' } },
            React.createElement(FontAwesomeIcon, { icon: faPaintBrush }),
            React.createElement("span", { className: "theme-selector-current" }, selectedThemeLabel)),
        open && (React.createElement("div", { className: "theme-selector-menu" }, THEMES.map(theme => (React.createElement("button", { key: theme.id, onClick: () => handleThemeSelect(theme.id), className: "theme-selector-option", "data-selected": currentTheme === theme.id },
            React.createElement(FontAwesomeIcon, { icon: theme.icon, className: "theme-color-dot", style: { color: theme.color } }),
            theme.label)))))));
};
export default ThemeSelector;
